import { ReactElement } from 'react';
import { TabPanel } from '@mui/lab';

import AccessFeatureAlert from '../Alert';
import AccessFeatureHidden from '../Hidden';

import { AccessFeatureTabPanelProps } from './types';

const AccessFeatureTabPanel = ({
  validFeature,
  availableToDate,
  children,
  ...restProps
}: AccessFeatureTabPanelProps): ReactElement => (
  <TabPanel {...restProps}>
    <AccessFeatureAlert
      validFeature={validFeature}
      availableToDate={availableToDate}
      gutters
    />

    <AccessFeatureHidden
      validFeature={validFeature}
      availableToDate={availableToDate}
      type="notAccess"
      validDemo
    >
      <>{children}</>
    </AccessFeatureHidden>
  </TabPanel>
);

export default AccessFeatureTabPanel;
